import { useResponsive } from "../../context/responsiveContext";
import { useTheme } from "../../context/themeContext";

export const useCookiesManagerStyles = () => {
  const theme = useTheme();
  const responsive = useResponsive();
  
  return {
    container: {
      width: '75vw',
      height: 'fit-content',
      borderRadius: '24px',
      position: 'fixed' as const,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      maxWidth: responsive.isBig ? 1120 : 600,
    },
    header: {
      backgroundColor: '#005891',
      color: 'white',
      textAlign: 'start' as const,
      borderRadius: '24px 24px 0 0',
      display: 'flex' as const,
      justifyContent: 'space-between' as const,
      alignItems: 'center' as const,
      position: 'relative' as const,
      paddingTop: responsive.isBig ? '2%' : 20,
      paddingRight: responsive.isBig ? '2%' : 20,
      paddingLeft: responsive.isBig ? '2%' : 20,
      paddingBottom: responsive.isBig ? '2%' : 20,
    },
    headerText: {
      margin: 0,
      fontSize: 18,
      fontWeight: 600,
    },
    close: {
      cursor: 'pointer',
      position: 'absolute' as const,
      top: 'auto' as const,
      right: '2%',
      width: 24,
      height: 24,
    },
    body: {
      display: 'flex' as const,
      flex: 4,
      height: '100%',
      background: theme.colors.background,
      borderRadius: '0px 0px 24px 24px',
      padding: '20px',
    },
    content: {
      display: 'flex' as const,
      flexDirection: 'column' as const,
      width: '100%',
      padding: 20,
    },
    text: {
      marginBottom: 30,
    },
    paragraph: {
      marginBottom: 15,
      color: theme.colors.text,
      fontSize: 16,
      lineHeight: 1.5,
    },
    link: {
      color: theme.colors.mainDark,
      textDecoration: 'none' as const,
      fontWeight: 600,
    },
    buttons: {
      display: 'flex' as const,
      justifyContent: 'center' as const, // Cambiado de 'flex-end' a 'center'
      gap: 15,
      flexDirection: responsive.isBig ? 'row' as const : 'column' as const,
    },
    acceptButton: {
      backgroundColor: theme.colors.mainDark,
      color: theme.colors.white,
      border: 'none',
      padding: '10px 20px',
      cursor: 'pointer',
      borderRadius: 4,
      fontWeight: 600,
      fontSize: 16,
    },
    declineButton: {
      backgroundColor: 'transparent',
      color: theme.colors.mainDark,
      border: `1px solid ${theme.colors.mainDark}`,
      padding: '10px 20px',
      cursor: 'pointer',
      borderRadius: 4,
      fontWeight: 600,
      fontSize: 16,
    },
  };
};
